import { BuyerSettings } from '../models/settings.model';
import { AccessLevel, UserType } from '@ps/core-models';

export interface AccessRequirement {
  roles?: UserType[];
  deniedRoles?: UserType[];
  accessLevels?: AccessLevel[];
  deniedAccessLevels?: AccessLevel[];
  flagName?: keyof BuyerSettings;
}

export function isRoleDenied(
  userType: UserType,
  allowed: UserType[],
  denied: UserType[],
): boolean {
  if (allowed.length && !allowed.includes(userType)) return true;
  if (denied.length && denied.includes(userType)) return true;
  return false;
}

export function isAccessLevelDenied(
  level: AccessLevel,
  allowed: AccessLevel[],
  denied: AccessLevel[],
): boolean {
  if (allowed.length && !allowed.includes(level)) return true;
  if (denied.length && denied.includes(level)) return true;
  return false;
}

/**
 * Pure access-control predicate that mirrors the roleGuard + featureFlagGuard logic.
 * Use inside computed() signals in components, or pass to CanAccessDirective.
 *
 * Feature flags (flagName) only apply to buyers; other user types bypass the check.
 */
export interface CanAccessOptions {
  userType: UserType;
  userAccessLevel: AccessLevel;
  config?: AccessRequirement;
  buyerSettings?: BuyerSettings;
}

export function canAccess({
  userType,
  userAccessLevel,
  config = {},
  buyerSettings = {},
}: CanAccessOptions): boolean {
  const {
    roles = [],
    deniedRoles = [],
    accessLevels = [],
    deniedAccessLevels = [],
    flagName,
  } = config;

  if (isRoleDenied(userType, roles, deniedRoles)) return false;
  if (isAccessLevelDenied(userAccessLevel, accessLevels, deniedAccessLevels))
    return false;
  if (flagName && userType === 'buyer' && !buyerSettings[flagName])
    return false;

  return true;
}
